export default {"src":"/_next/static/media/kn.5b547360.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};